<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item ><div style="display: inline-block;" @click="gotopage('/Channel/index.html')">渠道管理</div></el-breadcrumb-item>
            <el-breadcrumb-item>渠道管理</el-breadcrumb-item>
        </el-breadcrumb>

        <el-form :inline="true" :model="item" class="search">
            <el-form-item label="渠道名称">
                <el-input v-model="item.name" placeholder="请输入渠道名称"
                          size="small"></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
                <el-input v-model="item.mobile" placeholder="请输入手机号码"
                          size="small"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" size="medium">查询</el-button>
            </el-form-item>
        </el-form>

        <div class="btns">
            <el-button type="primary" size="small" @click="add">添加渠道</el-button>
            <el-button type="danger" size="small" @click="delAll">批量删除</el-button>
        </div>


        <el-table :data="list" border @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center"></el-table-column>
            <el-table-column prop="channel_id" width="80" align="center" label="渠道ID"></el-table-column>
            <el-table-column prop="name" label="渠道名称"></el-table-column>
            <el-table-column prop="link_man"  width="150" align="center" label="联系人"></el-table-column>
            <el-table-column prop="mobile" width="120" align="center" label="手机号码"></el-table-column>
            <el-table-column prop="access_key" width="160" align="center" label="accesskey"></el-table-column>
            <el-table-column prop="credit_fee" width="160" align="center" label="可用额度"></el-table-column>
            <el-table-column prop="total_credit_fee" width="160" align="center" label="总额度"></el-table-column>
            <el-table-column prop="access_secret" width="280" align="center" label="accessSecret"></el-table-column>
            <el-table-column label="操作" width="200" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="recharge(scope.row)">充值额度</el-button>
                    <el-button size="mini" type="primary" @click="edit(scope.row.channel_id)">编辑</el-button>
                    <el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.channel_id)" class="l10">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!--        @size-change= 每页多少条 -->
        <!--        @current-change 当前多少页-->
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
                       :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        <recharge ref="recharge" @reload="loadList"></recharge>
    </div>
</template>
<script>
    import Recharge from "./components/recharge";
    export default {
        name: 'index',
        components: {Recharge},
        data() {
            return {
                list: [],
                isLoad: false,
                pageSize: 20,
                total: 0,
                page: 1,
                number: 0,
                // 查询
                item: {}
            }
        },
        created() {
            this.loadList()
        },
        methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
            loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/admin/channel/list', {
                    page: this.page,
                    limit: this.pageSize,
                    name: this.item.name,
                    mobile: this.item.mobile,
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        this.list = res.data.list.data
                        this.total = res.data.total
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            add() {
                this.$router.push({path: '/Channel/edit.html'});
            },
            edit(id) {
                this.$router.push({
                    path: '/Channel/edit.html',
                    query: {
                        id: id
                    }
                });
            },
            //
            del(id) {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/channel/delete', {
                    data: {
                        channel_ids: id
                    }
                })
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '删除成功',
                            showClose: false
                        });
                        this.loadList()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAll() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.channel_id)
                }
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/channel/delete', {
                    data: {
                        channel_ids: id
                    }
                }).then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '删除成功',
                        showClose: false
                    });
                    this.loadList()
                })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            sizeReload(val) {
                this.pageSize = val
                this.loadList()
            },
            pageReload(val) {
                this.page = val
                this.loadList()
            },
            // 搜索查询
            submit() {
                this.item.page = 1
                this.loadList()
            },
            // 导出
            excelOut() {
                return;
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.get('/Member/excelOut', {
                    params: {
                        nickname: this.item.nickname,
                        title: this.item.title
                    }
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 导出
                        window.open(res.url)
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            recharge: function (row) {
                this.$refs.recharge.handle(row)
            }
        }
    }
</script>
<style scoped>
</style>
